import { startLoading, endLoading } from './app-dux';
import rosterService from '../services/roster';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    attributeTypes: []
};
/*******************************************************************************
 * Non-async action types
 */
export const SET_PERSON_ATTRIBUTES = 'SET_PERSON_ATTRIBUTES';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_PERSON_ATTRIBUTES: {
            return {
                ...state,
                attributeTypes: action.personAttributes
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function loadPersonAttributeTypes( accessToken, companyId ) {
    const RosterService = new rosterService( accessToken, companyId );

    return async ( dispatch ) => {
        try {
            dispatch( startLoading() );
            const attributes = await RosterService.getPersonAttributeTypes();
            dispatch( setPersonAttributes( attributes ) );
            return attributes;
        } finally {
            dispatch( endLoading() );
        }
    };
}

export function saveAttributeType( accessToken, companyId, attribute ) {
    const RosterService = new rosterService( accessToken, companyId );

    return async ( dispatch ) => {
        try {
            dispatch( startLoading() );

            await RosterService.createPersonAttributeType( attribute );

            const attributes = await RosterService.getPersonAttributeTypes();

            dispatch( setPersonAttributes( attributes ) );

            return attributes;

        } finally {
            dispatch( endLoading() );
        }
    };
}

export function setPersonAttributes( personAttributes ) {
    return {
        type: SET_PERSON_ATTRIBUTES,
        personAttributes
    };
}